/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 6000)

};

sections.extend('slideshow', slideshowAutoExtension);

//アコーディオンをクリックした時の動作
$('.title').on('click', function() {//タイトル要素をクリックしたら
  var findElm = $(this).next(".box");//直後のアコーディオンを行うエリアを取得し
  $(findElm).slideToggle();//アコーディオンの上下動作

  if($(this).hasClass('close')){//タイトル要素にクラス名closeがあれば
    $(this).removeClass('close');//クラス名を除去し
  }else{//それ以外は
    $(this).addClass('close');//クラス名closeを付与
  }
});

/* -----------------------------------------------------------------------------/
/  Variant availability — grey out / disable fully sold-out option values
/  (requirement 4.3). Works with the native <select> variant pickers in
/  snippets/product-form.liquid.
/
/  Policy: an option value is disabled + annotated "（在庫切れ）" ONLY when it
/  has NO available variant in ANY combination (i.e. the value is sold out for
/  every other option). This avoids the misleading case where e.g. "21cm" looks
/  fully sold out just because one colour of 21cm is out — 21cm stays selectable
/  as long as some colour of 21cm is in stock. A specific sold-out combination
/  (e.g. 21cm + 灰) is still communicated by the native add-to-cart button
/  switching to "売り切れ" when that exact variant is selected.
/
/  Runs once on load and again after each option change (idempotent). The
/  theme's own change handler (which runs morphdom) fires first because it is
/  bound on the product container; this document-delegated handler fires
/  afterwards, so its state is applied on top of the morphed DOM and preserved
/  (morphdom does not touch option disabled state or text).
/-----------------------------------------------------------------------------*/
(function () {
  var SOLD_OUT_SUFFIX = '（在庫切れ）';

  function getProduct($scope) {
    var $json = $scope.find('[data-product-json]').first();
    if (!$json.length) return null;
    try { return JSON.parse($json.html()); } catch (e) { return null; }
  }

  function applyAvailability($scope) {
    var product = getProduct($scope);
    if (!product || !product.variants) return;

    var $selects = $scope.find('[data-option-input]');
    if ($selects.length === 0) return;

    // Currently-selected value for each option position.
    var current = $selects.map(function () { return this.value; }).get();

    $selects.each(function (optIndex) {
      $(this).find('option').each(function () {
        var $opt = $(this);
        var value = this.value;

        // Remember the pristine label once so we can rebuild it each pass.
        if (typeof $opt.attr('data-orig-label') === 'undefined') {
          $opt.attr('data-orig-label', $opt.text());
        }
        var origLabel = $opt.attr('data-orig-label');

        // Is there ANY available variant having this value at optIndex
        // (regardless of the other options)? If not, the value is fully
        // sold out and should be disabled.
        var hasAvailable = product.variants.some(function (v) {
          return v.available && v.options[optIndex] === value;
        });

        var isSelected = (value === current[optIndex]);

        if (!hasAvailable && !isSelected) {
          $opt.prop('disabled', true).addClass('option--soldout');
          $opt.text(origLabel + ' ' + SOLD_OUT_SUFFIX);
        } else {
          $opt.prop('disabled', false).removeClass('option--soldout');
          $opt.text(origLabel);
        }
      });
    });
  }

  $(function () {
    var $scopes = $('.product-template');
    if ($scopes.length === 0) return;

    $scopes.each(function () { applyAvailability($(this)); });

    $(document).on('change', '[data-option-input]', function () {
      var $scope = $(this).closest('.product-template');
      if (!$scope.length) { $scope = $('.product-template').first(); }
      applyAvailability($scope);
    });
  });
})();

/* -----------------------------------------------------------------------------/
/  Variant → gallery image sync (requirement 4.4: switch the main image to the
/  selected variant's image without reload). The product gallery is a Swiper
/  (.swiper-container) initialised in the compiled bundle; the instance is read
/  from the element's `.swiper` property. Each slide carries data-media-src
/  (the media's master image URL). On variant change we find the slide whose
/  image matches the selected variant's featured_image and slideTo() it.
/
/  If the selected variant has no assigned image, the gallery is left as-is.
/-----------------------------------------------------------------------------*/
(function () {
  function fileName(url) {
    if (!url) return '';
    return url.split('?')[0].split('/').pop();
  }

  function getProduct($scope) {
    var $json = $scope.find('[data-product-json]').first();
    if (!$json.length) return null;
    try { return JSON.parse($json.html()); } catch (e) { return null; }
  }

  function selectedVariant(product, $scope) {
    var $selects = $scope.find('[data-option-input]');
    if ($selects.length === 0) return product.variants[0];
    var current = $selects.map(function () { return this.value; }).get();
    return product.variants.filter(function (v) {
      if (v.options.length !== current.length) return false;
      for (var i = 0; i < current.length; i++) {
        if (v.options[i] !== current[i]) return false;
      }
      return true;
    })[0];
  }

  function syncGallery($scope) {
    var product = getProduct($scope);
    if (!product) return;

    var variant = selectedVariant(product, $scope);
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;

    var $container = $scope.find('.swiper-container').first();
    var swiper = $container.length ? $container[0].swiper : null;
    if (!swiper) return;

    var target = fileName(variant.featured_image.src);
    var $slides = $container.find('.swiper-slide');
    for (var i = 0; i < $slides.length; i++) {
      if (fileName($slides.eq(i).attr('data-media-src')) === target) {
        swiper.slideTo(i);
        break;
      }
    }
  }

  $(function () {
    var $scopes = $('.product-template');
    if ($scopes.length === 0) return;

    // Defer initial sync so the Swiper instance is created first.
    setTimeout(function () {
      $scopes.each(function () { syncGallery($(this)); });
    }, 0);

    $(document).on('change', '[data-option-input]', function () {
      var $scope = $(this).closest('.product-template');
      if (!$scope.length) { $scope = $('.product-template').first(); }
      syncGallery($scope);
    });
  });
})();

/* -----------------------------------------------------------------------------/
/  C-2 Phase 2 — AJAX swap between sibling products (no full reload).
/
/  The colour / size controls rendered by snippets/product-line-selector.liquid
/  are real links ([data-line-link] → sibling product URL). Here we intercept a
/  plain left-click, fetch the target product page, and swap only the inner
/  regions of the existing .product-template container — keeping the container
/  itself (so the theme's delegated cart/variant handlers survive). The gallery
/  reuses the already-initialised Swiper instance (Swiper isn't global and there
/  is no build step, so it cannot be re-constructed). The URL is updated with
/  history.pushState.
/
/  SAFETY: on anything unexpected (missing regions, no Swiper, fetch error) we
/  fall back to normal navigation (location.href = url), i.e. behaviour C-1.
/  This guarantees add-to-cart and the page never end up in a broken state.
/-----------------------------------------------------------------------------*/
(function () {
  var SWAP_REGIONS = [
    '.product__title',
    '.product__price',
    '.shipping-incentive',
    '.product__description',
    '.product__form-wrapper',
    '.line-selector',
    '.sticky-atc'
  ];

  function navigate(url) { window.location.href = url; }

  function cleanUrl(url) { return (url || '').split('#')[0]; }

  // Fetch ONLY the product-template section (Section Rendering API) instead of
  // the whole page — much smaller/faster. Results are cached, and in-flight
  // requests are de-duplicated so hover-prefetch + click share one request.
  var sectionCache = {};
  var sectionInflight = {};

  function fetchSection(url) {
    url = cleanUrl(url);
    if (sectionCache[url]) { return Promise.resolve(sectionCache[url]); }
    if (sectionInflight[url]) { return sectionInflight[url]; }

    var reqUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=product-template';
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var killer = setTimeout(function () { if (ctrl) { ctrl.abort(); } }, 5000);

    var p = fetch(reqUrl, { headers: { 'X-Requested-With': 'fetch' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { clearTimeout(killer); if (!r.ok) throw new Error('bad ' + r.status); return r.json(); })
      .then(function (j) {
        var html = j['product-template'];
        if (!html) throw new Error('no section html');
        sectionCache[url] = html;
        delete sectionInflight[url];
        return html;
      })
      .catch(function (e) { clearTimeout(killer); delete sectionInflight[url]; throw e; });

    sectionInflight[url] = p;
    return p;
  }

  function prefetch(url) {
    url = cleanUrl(url);
    if (!url || sectionCache[url] || sectionInflight[url]) { return; }
    fetchSection(url).catch(function () {});
  }

  // The theme hides option/quantity <select>s (theme.scss: opacity:0) and only
  // reveals them via its own `_formatVariantSelectors` pass (sets a label-width
  // padding-left + opacity:1) that runs once on the section's initial onLoad.
  // The swapped-in form is fresh markup that never receives that pass — and on
  // real Shopify the product-template onLoad throws (out.js references an
  // undefined `_setFormPosition`) before it could re-run — so the quantity
  // <select> stays opacity:0 and renders as an empty (invisible) gray box.
  // Re-apply the same formatting to the swapped region to keep it visible.
  function formatVariantSelectors($scope) {
    $scope.find('.product-form__item').each(function () {
      var $item = $(this);
      var $label = $item.find('label').first();
      var $field = $item.find('select, input').first();
      if (!$field.length) return;
      $field.css({ 'padding-left': $label.length ? $label.outerWidth() : '', opacity: 1 });
    });
  }

  function rebuildPagination($container, swiper) {
    if (!swiper || !swiper.pagination || !swiper.pagination.el) return;
    try {
      swiper.pagination.render();
      swiper.pagination.update();
      // The bullet thumbnails were generated from the original product's images
      // at init; repaint them from the new slides.
      var $bullets = $(swiper.pagination.el).find('.swiper-pagination-bullet-thumb');
      var $imgs = $container.find('.swiper-slide img');
      $bullets.each(function (idx) {
        var src = $imgs.eq(idx).attr('src');
        if (src) { this.style.backgroundImage = 'url(' + src + ')'; }
      });
    } catch (e) { /* non-fatal */ }
  }

  function swapProduct(url, $scope) {
    url = cleanUrl(url);
    $scope.addClass('is-swapping');

    // Uses the cached/section fetch (instant on a cache hit from prefetch).
    // Any failure (incl. timeout) falls back to a normal navigation so the
    // control never gets stuck mid-swap.
    fetchSection(url)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newTemplate = doc.querySelector('.product-template');
        if (!newTemplate) throw new Error('no .product-template in response');

        // Swap the simple inner regions.
        SWAP_REGIONS.forEach(function (sel) {
          var oldEl = $scope.find(sel).first()[0];
          var newEl = newTemplate.querySelector(sel);
          if (oldEl && newEl) { oldEl.parentNode.replaceChild(newEl, oldEl); }
        });

        // Reveal the swapped-in option/quantity selects (theme hides them at
        // opacity:0 until its own formatter runs — which it won't, post-swap).
        formatVariantSelectors($scope);

        // Gallery: reuse the live Swiper instance, replace its slides only.
        var $container = $scope.find('.swiper-container').first();
        var swiper = $container.length ? $container[0].swiper : null;
        var newWrapper = newTemplate.querySelector('.swiper-wrapper');
        if (swiper && newWrapper) {
          $container.find('.swiper-wrapper').html(newWrapper.innerHTML);
          swiper.update();
          swiper.slideTo(0, 0);
          rebuildPagination($container, swiper);
        } else {
          // Can't safely reuse the gallery → hard navigate instead.
          navigate(url);
          return;
        }

        history.pushState({ lineSwap: true }, '', url);
        var newTitleEl = newTemplate.querySelector('.product__title');
        if (newTitleEl) { document.title = newTitleEl.textContent.trim(); }

        $scope.removeClass('is-swapping');
        // Let the variant-availability / gallery-sync extensions re-run.
        $(document).trigger('line:swapped', [$scope]);
      })
      .catch(function () { navigate(url); });
  }

  $(function () {
    if ($('[data-line-selector]').length === 0) return;

    // Prefetch sibling sections so a click swaps from cache (feels instant).
    // 1) On hover / press (covers the option the shopper is about to click,
    //    incl. links inserted after a swap).
    $(document).on('mouseover mousedown touchstart', '[data-line-link]', function () {
      prefetch(this.getAttribute('data-line-target'));
    });
    // 2) As soon as the browser is idle (much sooner than a fixed delay, but
    //    without competing with the critical page load), warm the cache for all
    //    siblings in this line (lines are small — a handful of products).
    var warmCache = function () {
      var seen = {};
      $('[data-line-link]').each(function () {
        var u = this.getAttribute('data-line-target');
        if (u && !seen[u]) { seen[u] = 1; prefetch(u); }
      });
    };
    if (window.requestIdleCallback) { requestIdleCallback(warmCache, { timeout: 1200 }); }
    else { setTimeout(warmCache, 200); }

    $(document).on('click', '[data-line-link]', function (e) {
      // Respect new-tab / modified clicks and let the browser handle them.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.which === 2) return;

      var url = this.getAttribute('data-line-target');
      if (!url) return;

      var $scope = $(this).closest('.product-template');
      if (!$scope.length) return;

      // No-op when clicking the already-selected option.
      var here = window.location.pathname;
      if (url.split('?')[0] === here) { e.preventDefault(); return; }

      e.preventDefault();
      swapProduct(url, $scope);
    });

    // A swapped URL differs from the loaded document; reload on back/forward
    // so the page is always consistent.
    window.addEventListener('popstate', function (ev) {
      if (ev.state && ev.state.lineSwap) { window.location.reload(); }
    });
  });
})();

/* -----------------------------------------------------------------------------/
/  Optimistic add-to-cart button transition
/
/  The theme only flips "カートに追加する" → "カートを見る" (＋"商品がカートに
/  追加されました") AFTER /cart/add.js AND a follow-up /cart.js (getCart) both
/  resolve — two sequential round-trips, which is the perceptible lag. The cart
/  add itself is fired by the theme's own submit handler (bound on the section
/  container); we bind on document so we run AFTER it (the add is already in
/  flight) and just paint the success state immediately. The theme's real
/  _transitionAddToCartButton then sets the identical state when it resolves
/  (idempotent). On a failed add we revert, since the theme shows its own error.
/-----------------------------------------------------------------------------*/
(function () {
  if (typeof $ === 'undefined') return;

  var BTN = '[data-cart-submit]';
  var PRIMARY = '[data-cart-primary-submit-text]';
  var SECONDARY = '[data-cart-secondary-submit-text]';
  var NOTE = '[data-cart-notification]';
  var C_TRANS = 'btn--to-secondary-transitioned';
  var C_TOGGLE = 'ajax-cart__toggle';
  var C_NOTE_OK = 'product__notification--success';
  var C_NOTE_ERR = 'product__notification--error';

  function str(key) { return (window.theme && theme.strings && theme.strings[key]) || ''; }

  $(document).on('submit', '.product-form', function () {
    var $btn = $(this).find(BTN).first();
    // Skip sold-out (disabled) and the "view cart" re-click (already toggled).
    if (!$btn.length || $btn.prop('disabled') || $btn.hasClass(C_TOGGLE)) return;

    $btn.addClass(C_TRANS + ' ' + C_TOGGLE);
    if (str('viewCart')) $btn.attr('aria-label', str('viewCart'));
    $(this).find(PRIMARY).attr('aria-hidden', true);
    $(this).find(SECONDARY).attr('aria-hidden', false);
    $(this).find(NOTE).removeClass(C_NOTE_ERR).addClass(C_NOTE_OK)
      .text(str('addItemSuccess')).attr('role', 'alert');
  });

  $(document).on('variant_add_to_cart_fail', function () {
    $(BTN).each(function () {
      var $btn = $(this), $form = $btn.closest('.product-form');
      $btn.removeClass(C_TRANS + ' ' + C_TOGGLE);
      if (str('addToCart')) $btn.attr('aria-label', str('addToCart'));
      $form.find(PRIMARY).attr('aria-hidden', false);
      $form.find(SECONDARY).attr('aria-hidden', true);
      $form.find(NOTE).removeClass(C_NOTE_OK);
    });
  });
})();

/* -----------------------------------------------------------------------------/
/  Instant-ish navigation: prefetch internal links on hover / touch
/
/  Shopify navigations are full page loads, so each one re-downloads the same
/  theme + app JS. Prefetching the next document on hover (à la instant.page)
/  lets the browser fetch it before the click so navigation feels instant.
/  Low-risk: rel=prefetch is a low-priority hint, deduped, and skips
/  cart/checkout/account/external/new-tab links and the C-2 swap links.
/-----------------------------------------------------------------------------*/
(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var done = {};
  var HOVER_DELAY = 65;
  var SKIP_PATH = /\/(cart|checkout|account|orders|challenge|admin)(\/|$|\?|#)/;
  var timer;

  function eligible(a) {
    if (!a || a.tagName !== 'A' || !a.href) return false;
    if (a.origin !== location.origin) return false;
    if (a.hasAttribute('download') || a.hasAttribute('data-line-link')) return false;
    if (a.target && a.target !== '_self') return false;
    if ((a.getAttribute('rel') || '').indexOf('nofollow') > -1) return false;
    var url = a.href.split('#')[0];
    if (url === location.href.split('#')[0]) return false;
    if (done[url] || SKIP_PATH.test(a.pathname)) return false;
    return url;
  }

  function prefetch(url) {
    done[url] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }

  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    var url = a && eligible(a);
    if (!url) return;
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(url); }, HOVER_DELAY);
    a.addEventListener('mouseleave', function () { clearTimeout(timer); }, { once: true });
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    var url = a && eligible(a);
    if (url) prefetch(url);
  }, { capture: true, passive: true });
})();

/* -----------------------------------------------------------------------------/
/  Shipping incentive — keep the "あと¥Xで送料無料" line in sync (施策③)
/
/  The box is server-rendered (snippets/shipping-incentive.liquid) from the
/  current variant's price PLUS the cart total (= how much more the shopper
/  needs if they add this item). JS keeps it fresh:
/    - on load, refetch /cart.js (the server-rendered cart total can be stale
/      on cached pages) and recompute
/    - on same-product variant change, recompute from the product JSON
/    - after an add-to-cart, refetch the cart and recompute
/    - after a C-2 color/size swap (line:swapped), the box arrives re-rendered
/      by the server; re-apply the freshest known cart total on top
/  Premises (sections/product-template.liquid): native selects firing `change`
/  ([data-option-input]/[data-master-select] — the same hooks out.js listens
/  to), and product JSON in <script type="application/json" data-product-json>.
/  As of now the theme's price morphdom does not touch this box (it sits
/  outside .product__price).
/
/  Units: Shopify prices are in the currency subunit (JPY: 銭 = 円 × 100), as is
/  data-threshold. Prices are whole yen so /100 is exact; floor is defensive.
/-----------------------------------------------------------------------------*/
(function () {
  if (typeof $ === 'undefined') return;

  function formatYen(moneySubunits) {
    return '¥' + Math.floor(moneySubunits / 100).toLocaleString('ja-JP');
  }

  function currentVariant($scope, $box) {
    var $json = $scope.find('[data-product-json]').first();
    var $select = $scope.find('[data-master-select]').first();
    if ($json.length && $select.length) {
      // JSON <script> — read with .text(); .html() could be entity-escaped.
      try {
        var product = JSON.parse($json.text());
        var id = parseInt($select.val(), 10);
        var v = (product.variants || []).filter(function (x) { return x.id === id; })[0];
        if (v && typeof v.price === 'number') {
          return { price: v.price, available: v.available !== false };
        }
      } catch (e) { /* fall through */ }
    }
    var fallback = Number($box.attr('data-variant-price'));
    if (!Number.isFinite(fallback)) return null;
    return { price: fallback, available: $box.attr('data-variant-available') !== 'false' };
  }

  function update($scope) {
    var $box = $scope.find('[data-shipping-incentive]').first();
    if (!$box.length) return;
    var threshold = Number($box.attr('data-threshold'));
    if (!Number.isFinite(threshold) || threshold <= 0) return;
    var v = currentVariant($scope, $box);
    if (!v) return;
    var price = v.price;
    var cartTotal = Number($box.attr('data-cart-total'));
    if (!Number.isFinite(cartTotal) || cartTotal < 0) cartTotal = 0;
    // 残額は選択中の数量を反映（単価×数量＋カート合計）。サーバー描画は数量1
    // 前提だが、数量の初期値は常に1なので初期表示と齟齬はない。
    var qty = parseInt($scope.find('.product-form [name="quantity"]').val(), 10);
    if (!Number.isFinite(qty) || qty < 1) { qty = 1; }

    // Mirror the Liquid branching: state the condition (この商品を追加すると…)
    // so a cart-only-not-yet-free shopper doesn't misread it as already free.
    var $line = $box.find('[data-shipping-remaining]');
    var effective = price * qty + cartTotal;
    if (v.available === false) {
      // 売り切れ時は Liquid と同じ再販通知の文言（クーポン行はそのまま）
      $line.text('ただいま売り切れ中です。再販の際はLINEでお知らせします');
    } else if (price >= threshold) {
      $line.html(formatYen(threshold) + '以上のため<strong>送料無料</strong>です');
    } else if (cartTotal >= threshold) {
      $line.html('カート内のご注文は<strong>送料無料</strong>です');
    } else if (effective >= threshold) {
      $line.html('この商品を追加すると<strong>送料無料</strong>になります');
    } else if (cartTotal > 0) {
      $line.html('カート内と合わせてあと<strong>' + formatYen(threshold - effective) + '</strong>で送料無料（' + formatYen(threshold) + '以上）');
    } else {
      $line.html('あと<strong>' + formatYen(threshold - effective) + '</strong>で送料無料（' + formatYen(threshold) + '以上）');
    }
  }

  function refreshCart($scope) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          $scope.find('[data-shipping-incentive]').attr('data-cart-total', cart.total_price);
          update($scope);
        }
      })
      .catch(function () { /* keep the server-rendered value */ });
  }

  $(function () {
    var $scope = $('.product-template').first();
    if (!$scope.length || !$scope.find('[data-shipping-incentive]').length) return;

    refreshCart($scope);

    $(document).on('change', '[data-option-input], [data-master-select], .product-form [name="quantity"]', function () {
      var $s = $(this).closest('.product-template');
      if ($s.length) { update($s); }
    });

    // After an add-to-cart the total changes; give /cart/add.js a moment.
    $(document).on('submit', '.product-form', function () {
      setTimeout(function () { refreshCart($scope); }, 1200);
    });

    $(document).on('line:swapped', function () { refreshCart($scope); });
  });
})();

/* -----------------------------------------------------------------------------/
/  Mobile sticky add-to-cart bar (PDP改修#11)
/
/  Shown (mobile widths only — CSS gates the display) while the main add-to-cart
/  button is scrolled out of view above. The bar is a PROXY for the main CTA:
/  clicking it clicks the main button, so the theme's AJAX add, the optimistic
/  カートを見る flip and the cart drawer all behave identically. Its price /
/  shipping subtext / button state MIRROR the main DOM nodes
/  (.product__current-price, [data-shipping-remaining], [data-cart-submit]) via
/  a debounced MutationObserver, so every path that updates those (morphdom,
/  shipping refresh, C-2 swaps — the bar itself is also in SWAP_REGIONS)
/  propagates here without duplicated logic.
/-----------------------------------------------------------------------------*/
(function () {
  if (typeof $ === 'undefined') return;

  $(function () {
    var $scope = $('.product-template').first();
    if (!$scope.length || !$scope.find('[data-sticky-atc]').length) return;

    // The bar is a mobile-only feature (CSS hides it >=750px); gate the JS on
    // the same media query so desktop pays no observer cost.
    var mq = window.matchMedia('(max-width: 749px)');
    var started = false;
    var io = null;
    var mo = null;
    var debounceTimer = null;

    function bar() { return $scope.find('[data-sticky-atc]')[0] || null; }
    function mainButton() { return $scope.find('.product-form [data-cart-submit]').first()[0] || null; }

    function setText($el, text) { if ($el.length && $el.text() !== text) { $el.text(text); } }

    function hideBar() {
      var b = bar();
      if (!b) return;
      b.classList.remove('is-visible');
      b.setAttribute('aria-hidden', 'true');
    }

    function observeMutations() {
      mo.observe($scope[0], { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
    }

    function syncBar() {
      var b = bar();
      if (!b) return;
      // Pause the observer while we write so our own mutations don't echo back
      // (setText is also change-guarded, so a stray cycle settles immediately).
      if (mo) { mo.disconnect(); }
      try {
        var main = mainButton();
        var $b = $(b);
        var $btn = $b.find('[data-sticky-submit]');

        if (!main) { hideBar(); return; }

        if (main.disabled) {
          $btn.prop('disabled', true).removeClass('is-toggled');
          setText($btn, ($(main).find('[data-cart-primary-submit-text]').text() || '').trim() || '売り切れ');
        } else if (main.classList.contains('ajax-cart__toggle')) {
          // カート追加後はメインCTAと同様に色反転（.is-toggled）して状態変化を明示
          $btn.prop('disabled', false).addClass('is-toggled');
          setText($btn, ($(main).find('[data-cart-secondary-submit-text]').text() || '').trim() || 'カートを見る');
        } else {
          $btn.prop('disabled', false).removeClass('is-toggled');
          setText($btn, 'カートに追加する');
        }

        // 数量が2以上のときは「単価×数量（n点）」で表示し、ボタンが実際に
        // 追加する内容（選択数量ぶん）と金額表示を一致させる。
        var price = $scope.find('.product__current-price').first().text().trim();
        if (price) {
          var qty = parseInt($scope.find('.product-form [name="quantity"]').val(), 10);
          if (Number.isFinite(qty) && qty > 1) {
            var unit = parseInt(price.replace(/[^\d]/g, ''), 10);
            if (Number.isFinite(unit)) {
              price = '¥' + (unit * qty).toLocaleString('ja-JP') + '（' + qty + '点）';
            }
          }
          setText($b.find('[data-sticky-price]'), price);
        }
        // Missing source → empty subtext (the row just collapses) rather than stale info.
        // The bar sub is a single ellipsized line (~18 chars at 390px), so use a
        // SHORT restock message when sold out and drop the （¥10,000以上） suffix
        // from the mirrored shipping copy — the full text stays in the PDP box.
        var $sub = $b.find('[data-sticky-sub]');
        if (main.disabled) {
          // 売り切れ時はLINEへのリンクにする（data-mode ガードで再書き込みループを防止）
          if ($sub.attr('data-mode') !== 'restock') {
            $sub.attr('data-mode', 'restock').html(
              '<a class="sticky-atc__sub-link" href="https://line.me/R/ti/p/%40041mcidp" target="_blank" rel="noopener noreferrer" aria-label="LINE友だち登録で再販通知を受け取る（新しいタブで開きます）" data-ga4-event="line_restock_click">再販はLINEでお知らせします</a>'
            );
          }
        } else {
          if ($sub.attr('data-mode') === 'restock') { $sub.removeAttr('data-mode').empty(); }
          var sub = $scope.find('[data-shipping-remaining]').first().text().replace(/\s+/g, ' ').trim();
          sub = sub.replace(/（[^）]*以上）/, '').trim();
          setText($sub, sub);
        }
      } finally {
        if (mo && started) { observeMutations(); }
      }
    }

    function observeMain() {
      if (io) { io.disconnect(); io = null; }
      var main = mainButton();
      if (!main || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Show only once the CTA has scrolled out ABOVE the viewport, so the
        // bar doesn't flash before the shopper reaches the form.
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        var b = bar();
        if (!b) return;
        b.classList.toggle('is-visible', show);
        b.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(main);
    }

    function start() {
      if (started) return;
      started = true;
      mo = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(syncBar, 60);
      });
      observeMutations();
      syncBar();
      observeMain();
    }

    function stop() {
      if (!started) return;
      started = false;
      if (mo) { mo.disconnect(); mo = null; }
      if (io) { io.disconnect(); io = null; }
      clearTimeout(debounceTimer);
      hideBar();
    }

    // Attached once (delegated) — no duplicate registration across swaps.
    // Proxy click → the main button (submit or open the cart drawer, whichever
    // its current state does). No-op when the main CTA is missing or disabled.
    $scope.on('click', '[data-sticky-submit]', function () {
      var main = mainButton();
      if (main && !main.disabled) { main.click(); }
    });

    // A <select> value change doesn't mutate the DOM, so the MutationObserver
    // can't see quantity changes — resync explicitly.
    $scope.on('change', '.product-form [name="quantity"]', function () {
      if (started) { syncBar(); }
    });

    // Swaps replace both the bar and the main button; the MutationObserver
    // watches the persistent $scope root so only the IO needs re-attaching.
    $(document).on('line:swapped', function () { if (started) { observeMain(); syncBar(); } });

    if (mq.matches) { start(); }
    var onMq = function (e) { if (e.matches) { start(); } else { stop(); } };
    if (mq.addEventListener) { mq.addEventListener('change', onMq); }
    else if (mq.addListener) { mq.addListener(onMq); }
  });
})();

/* -----------------------------------------------------------------------------/
/  Cart-drawer cross-sell (PDP改修#9・カート版) — 「＋追加」
/
/  Initial markup is server-rendered from cart.items.first's cross_sell_candidates
/  (snippets/cart-drawer.liquid), which also embeds the FULL unfiltered candidate
/  list as JSON (data-cart-cross-sell-source) precisely so the add flow never
/  needs a full-page re-render: cart-drawer.liquid is a SNIPPET (included in
/  theme.liquid), not a registered section, so it isn't reachable via the
/  Section Rendering API, and re-fetching the whole current page (a product
/  page, with its images/sliders/reviews) was the reported slowness. Instead,
/  after /cart/add.js we fetch only /cart.js (small JSON, matching how the
/  theme's own native quantity/delete controls refresh the drawer) and rebuild
/  the list client-side using the embedded candidate data — one lightweight
/  round trip total instead of two heavy ones.
/
/  Known gap: the theme's own native quantity/delete controls in the drawer
/  don't trigger this recompute either (same as before), so the suggestion can
/  go stale until the drawer is reopened or the page reloads. The add flow —
/  the actual conversion action — always stays correct.
/-----------------------------------------------------------------------------*/
(function () {
  if (typeof $ === 'undefined') return;

  function formatYen(moneySubunits) {
    return '¥' + Math.floor(moneySubunits / 100).toLocaleString('ja-JP');
  }

  function getSource($box) {
    var $script = $box.find('[data-cart-cross-sell-source]').first();
    if (!$script.length) return [];
    try { return JSON.parse($script.text()) || []; } catch (e) { return []; }
  }

  function buildRow(candidate) {
    var $item = $('<div class="cart-drawer__cross-sell-item"></div>');
    var $media = $('<a class="cart-drawer__cross-sell-media"></a>').attr('href', candidate.url);
    if (candidate.image) {
      $('<img loading="lazy" width="40" height="40">').attr({ src: candidate.image, alt: candidate.title }).appendTo($media);
    }
    var $info = $('<span class="cart-drawer__cross-sell-info"></span>');
    $('<a class="cart-drawer__cross-sell-name"></a>').attr('href', candidate.url).text(candidate.title).appendTo($info);
    $('<span class="cart-drawer__cross-sell-price"></span>').text(formatYen(candidate.price)).appendTo($info);
    var $btn = $('<button type="button" class="cart-drawer__cross-sell-add" data-cart-cross-sell-add data-ga4-event="cross_sell_add_click">＋追加</button>')
      .attr('data-cart-cross-sell-variant-id', candidate.variant_id);
    $item.append($media, $info, $btn);
    return $item;
  }

  // /cart.js の最新カート状態を使って、埋め込み済みの候補データから
  // 「カートに未投入・在庫あり」を最大3件まで再構成する（Liquid側と同じロジック）。
  function recompute($box, cart) {
    var threshold = Number($box.attr('data-cart-cross-sell-threshold'));
    if (!Number.isFinite(threshold)) return;
    var remaining = threshold - cart.total_price;

    if (remaining <= 0) { $box.hide(); return; }

    var inCartIds = {};
    cart.items.forEach(function (item) { inCartIds[item.product_id] = true; });

    var candidates = getSource($box).filter(function (c) {
      return c.available && !inCartIds[c.product_id];
    }).slice(0, 3);

    if (!candidates.length) { $box.hide(); return; }

    $box.find('[data-cart-cross-sell-lead] strong').text(formatYen(remaining));
    var $list = $box.find('[data-cart-cross-sell-list]').empty();
    candidates.forEach(function (c) { $list.append(buildRow(c)); });
    $box.show();
  }

  // テーマ純正のカートドロワー再描画（小計・商品リスト・割引・チェックアウトボタン状態）。
  // window.theme.sections は out.js のセクションフレームワークの公開エントリポイントで、
  // 各インスタンスの update(cart) は _createCart(cart) でクローン＋部分更新した DOM を
  // morphdom 適用する（テーマの数量変更・削除ボタンと全く同じ正規の仕組み）。
  // instances[0].refresh() も同じ描画をするが、内部で ne.getCart()（＝もう一度 /cart.js
  // 相当の通信）をしてから update() を呼ぶため、直列で3回目の通信が発生し体感が遅くなる。
  // 既に自分で取得済みの cart データをそのまま update() に渡し、その通信を省略する。
  // 私のクロスセルブロックは _createCart が触らない領域なので、直前に自分のJSで更新した
  // 内容がクローンにそのまま保持され競合しない。
  var suppressNextSync = false;

  function updateNativeCartDrawer(cart) {
    if (!window.theme || !window.theme.sections || typeof window.theme.sections.getInstances !== 'function') return;
    window.theme.sections.getInstances('cart-drawer').then(function (instances) {
      if (instances && instances[0] && typeof instances[0].update === 'function') {
        // 直後に発火する自分自身のMutationObserver再同期（下記）を1回だけ抑止する。
        // このupdate()自体が既に正しいcartデータで小計・クロスセルを描画済みのため。
        suppressNextSync = true;
        instances[0].update(cart);
      }
    });
  }

  // 純正の数量変更・削除ボタンはこのクロスセル機能の再計算をトリガーしない既知の
  // ギャップがあったが、実機検証で「削除直後は小計の表示自体も古いままになる」ことが
  // 判明した（サーバー側のカートは正しいがDOM表示が同期されない）。カート内アイテム
  // リストのDOM変化を監視し、変化元（純正ボタン／自分のcrossSell追加）を問わず一元的に
  // 最新の /cart.js を取り直して小計とクロスセル表示を同期させる。
  var $itemList = document.querySelector('[data-cart-item-list]');
  if ($itemList && window.MutationObserver) {
    var syncTimer = null;
    var observer = new MutationObserver(function () {
      if (suppressNextSync) { suppressNextSync = false; return; }
      if (syncTimer) return;
      syncTimer = setTimeout(function () {
        syncTimer = null;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            $('[data-cart-subtotal]').text(formatYen(cart.total_price));
            $('[data-cart-cross-sell]').each(function () { recompute($(this), cart); });
          });
      }, 150);
    });
    observer.observe($itemList, { childList: true, subtree: true });
  }

  $(document).on('click', '[data-cart-cross-sell-add]', function (e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.prop('disabled')) return;
    var variantId = parseInt($btn.attr('data-cart-cross-sell-variant-id'), 10);
    if (!Number.isFinite(variantId)) return;
    var $box = $btn.closest('[data-cart-cross-sell]');
    var originalText = $btn.text();
    // 楽観的表示: 実際のカート反映を待たずに即座に見た目を変える（体感速度向上）。
    $btn.prop('disabled', true).text('追加しました');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) { throw new Error('cart cross-sell add failed'); } return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        recompute($box, cart);
        updateNativeCartDrawer(cart);
      })
      .catch(function () {
        $btn.prop('disabled', false).text(originalText);
      });
  });
})();
